import { render } from "./UploadView.vue?vue&type=template&id=52067eb2&scoped=true"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"

import "./UploadView.vue?vue&type=style&index=0&id=52067eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52067eb2"]])

export default __exports__